import type { Economy } from './loadEconomy'

/** The UTC calendar day of `date` as `YYYY-MM-DD`; daily tasks reset at UTC midnight. */
export function utcDay(date: Date): string {
  return date.toISOString().slice(0, 10)
}

/** 32-bit FNV-1a over UTF-16 code units. */
export function fnv1a(s: string): number {
  let h = 0x811c9dc5
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i)
    h = Math.imul(h, 0x01000193)
  }
  return h >>> 0
}

/** mulberry32: a small seeded generator of floats in [0, 1). */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0
  return () => {
    a = (a + 0x6d2b79f5) >>> 0
    let t = Math.imul(a ^ (a >>> 15), 1 | a)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

/**
 * Today's daily task ids for a user (D-038): `daily.count` distinct ids, the same on server and
 * client without storing the pick. FNV-1a of `userId + day` seeds mulberry32, which drives a
 * Fisher–Yates shuffle (from the last index down) of the pool in file order; the first `count`
 * ids win. Changing the pool or its order reshuffles everyone's day.
 */
export function dailyTasksFor(userId: string, day: string, economy: Economy): string[] {
  const ids = economy.daily.tasks.map((t) => t.id)
  const random = mulberry32(fnv1a(userId + day))
  for (let i = ids.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1))
    const tmp = ids[i]!
    ids[i] = ids[j]!
    ids[j] = tmp
  }
  return ids.slice(0, economy.daily.count)
}
